<div class="container">
  <div class="etapas-container">
    <div
      class="etapa"
      *ngFor="let etapa of etapas; let i = index"
      [class.ativa]="i + 1 === etapaSelecionada"
      (click)="selecionarEtapa(i + 1)"
    >
      <span class="numero">{{ i + 1 }}.</span> {{ etapa }}
    </div>
  </div>
</div>
